var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.evaluationFormComponentName,{tag:"component",on:{"close-modal":_vm.saveEvaluation},model:{value:(_vm.proposal),callback:function ($$v) {_vm.proposal=$$v},expression:"proposal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }